import React from "react";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./ParticipantResult.scss";
import { GameOutcome as Outcome } from "../../../utils/constants";
import PersonIcon from "../../icons/PersonIcon";
import LoadingDots from "../../LoadingDots/LoadingDots";
import ImageCrown from "../../../images/crown.svg";

interface ParticipantResultProps {
  isLoggedInUser?: boolean;
  outcome?: Outcome;
  username?: string;
  avatar?: string;
  score?: number;
  isForLoader?: boolean;
}

function ParticipantResult({
  isLoggedInUser,
  outcome,
  username,
  avatar,
  score,
  isForLoader,
}: ParticipantResultProps) {
  const { t } = useTranslation("games");

  let imgBg: string | undefined;
  switch (true) {
    case !username || outcome === Outcome.CANCELLED:
      imgBg = "#F3CC57";
      break;
    case isLoggedInUser:
      imgBg = undefined;
      break;
    case outcome === Outcome.AWAITING_SCORE:
      imgBg = "#131313";
      break;
    default:
      imgBg = "#ddcfc9";
  }

  const outcomeClassMap: Partial<Record<Outcome, string>> = {
    [Outcome.WIN]: "outcome-win",
    [Outcome.LOSS]: "outcome-loss",
    [Outcome.DRAW]: "outcome-draw",
  };

  return (
    <div
      className={`participant-result position-relative align-self-stretch ${outcomeClassMap[outcome!] ?? ""}`}
    >
      <div className="box-container">
        <div
          className="img-box"
          style={{
            width: outcome === Outcome.WIN ? undefined : 80,
            height: outcome === Outcome.WIN ? undefined : 80,
            background: imgBg,
          }}
        >
          {avatar && username && outcome !== Outcome.CANCELLED ? (
            <Image
              src={avatar}
              alt=""
            />
          ) : (
            <PersonIcon fill="#29292D" width={32} height={40} />
          )}
        </div>
      </div>

      {username && outcome !== Outcome.CANCELLED ? (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <p className="username slashed-zero mb-2">
            {isLoggedInUser ? t("you") : `@${username}`}
          </p>
          <p className="points">
            {outcome === Outcome.AWAITING_SCORE ? "---" : score?.toLocaleString()}
          </p>
          <p
            className="label"
            style={{
              color: outcome === Outcome.AWAITING_SCORE ? "#BFBFBF" : undefined,
            }}
          >
            {outcome === Outcome.AWAITING_SCORE && !isForLoader ? (
              t("still_playing")
            ) : (
              <span className="text-uppercase">{t("points")}</span>
            )}
          </p>
        </div>
      ) : (
        <div className="searching d-flex justify-content-center align-items-end">
          <p>{t("searching")}</p>
          <LoadingDots
            dotStyles={{ background: "white", height: 2, width: 2 }}
            containerStyles={{ marginBottom: 2 }}
          />
        </div>
      )}
      {outcome === Outcome.WIN && (
        <p className="crown-box">
          <Image src={ImageCrown} width={20} alt="crown" />
        </p>
      )}
    </div>
  );
}

export default ParticipantResult;
